import { Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { TransferState, makeStateKey } from '@angular/core';

@Injectable()
export class EcapCorporateIdentityService {
    public langKey: string;
    public constructor(private titleService: Title, private meta: Meta) { }
    public setTitle(newTitle: string) {
        this.titleService.setTitle(newTitle);
    }
    public getTitle(): string {
        return this.titleService.getTitle();
    }

    public setLangKey(langKey: string) {
        this.langKey = langKey;
    }
    public getLangKey(): string {
        return this.langKey;
    }

    public setMetaTag(meta: IMeta[]) {
        meta.forEach(metaData => {
            this.meta.addTag({ name: metaData.name, content: metaData.content });
        });
    }
}

export interface IMeta {
    name: string,
    content: string
}